import { HeaderPage } from "@/organisms/HeaderPage"
import { VirtualMachinesTab } from "@/pages/DiscoveryPage/components/organisms/VirtualMachinesTab"
import { useActiveKeyTabsInventory } from "@/pages/DiscoveryPage/hooks/useActiveKeyTabsInventory"
import { PageTemplate } from "@/templates/PageTemplate"

export const VirtualMachinesPage = () => (
  <PageTemplate
    full
    header={<HeaderPage titleTranslationKey="navigation.vm" />}
  >
    <VirtualMachinesTab useActiveKeyTabsInventory={useActiveKeyTabsInventory} />
  </PageTemplate>
)
